var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7138 39.5128C49.9649 33.1865 50.7731 25.157 47.8714 18.1112C44.9672 11.0654 38.7367 5.93785 31.2642 4.44219C23.7918 2.94904 16.0656 5.28921 10.6774 10.6773C5.28917 16.0655 2.94895 23.7917 4.44227 31.2642C5.93769 38.7366 11.0655 44.9671 18.1113 47.8713C25.1571 50.7731 33.1865 49.9649 39.5128 45.7138L52.6272 58.8235C54.3555 60.4331 57.0473 60.3852 58.7162 58.7162C60.3852 57.0473 60.4331 54.3555 58.8235 52.6272L45.7138 39.5128ZM39.0678 28.547C39.0678 29.515 38.2824 30.3004 37.3144 30.3004H30.3008V37.314C30.3008 38.282 29.5154 39.0674 28.5474 39.0674H25.0405C24.0725 39.0674 23.2871 38.282 23.2871 37.314V30.3004H16.2735C15.3055 30.3004 14.5201 29.515 14.5201 28.547V25.0401C14.5201 24.0721 15.3055 23.2867 16.2735 23.2867H23.2871V16.2731C23.2871 15.3051 24.0725 14.5196 25.0405 14.5196H28.5474C29.5154 14.5196 30.3008 15.3051 30.3008 16.2731V23.2867H37.3144C38.2824 23.2867 39.0678 24.0721 39.0678 25.0401V28.547Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom_in.7c48ac51.svg";
export { ForwardRef as ReactComponent };